export const handleOpenCookieManager = () => {
  if (window)
    window.location.href = `${window.location.href.split("#")[0]}#cookie-manager`;
};
